/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AccountApiService } from './services/account-api.service';
import { AiUsageApiService } from './services/ai-usage-api.service';
import { ClientsApiService } from './services/clients-api.service';
import { DeveloperApiService } from './services/developer-api.service';
import { ErrorLogApiService } from './services/error-log-api.service';
import { HealthCheckApiService } from './services/health-check-api.service';
import { MetricLibraryApiService } from './services/metric-library-api.service';
import { NavigationApiService } from './services/navigation-api.service';
import { PermissionsApiService } from './services/permissions-api.service';
import { ReleaseNotesApiService } from './services/release-notes-api.service';
import { TicketsApiService } from './services/tickets-api.service';
import { TicketStatusApiService } from './services/ticket-status-api.service';
import { UsersApiService } from './services/users-api.service';
import { WebhookApiService } from './services/webhook-api.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AccountApiService,
    AiUsageApiService,
    ClientsApiService,
    DeveloperApiService,
    ErrorLogApiService,
    HealthCheckApiService,
    MetricLibraryApiService,
    NavigationApiService,
    PermissionsApiService,
    ReleaseNotesApiService,
    TicketsApiService,
    TicketStatusApiService,
    UsersApiService,
    WebhookApiService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
